import AppCard, { ExtendedGlobalApp } from "../../Cards/AppCard";
import AppEmptyState from "../../../../elements/AppEmptyState";
import { useAtomValue } from "jotai";
import { workspaceIdAtom } from "../../../../atoms/WorkspaceAtoms";
import useInstallGlobalApp from "../../../../api/api-hooks/globalApps/useInstallGlobalApp";

interface Props {
  allInstalledApps: ExtendedGlobalApp[];
  pendingUpdateApps: ExtendedGlobalApp[];
  openApp: (appID: string) => void;
}

const SectionTitle = ({ children }: { children: React.ReactNode }) => (
  <h3 className="tw:mx-2 tw:py-3 tw:mb-4 tw:text-black tw:border-b tw:border-superlight">
    {children}
  </h3>
);

const InstalledApps = ({
  allInstalledApps,
  pendingUpdateApps,
  openApp,
}: Props) => {
  const workspaceID = useAtomValue(workspaceIdAtom);
  const { installGlobalApp, installID } = useInstallGlobalApp();

  const handleClick = (app: ExtendedGlobalApp) => {
    openApp(app._id || app.id);
  };

  const pendingUpdatesFromOtherClouds = pendingUpdateApps.filter(
    (app) => !app.isSameCloud
  );

  return (
    <div className="tw:flex tw:flex-col tw:justify-center tw:md:justify-start tw:px-3 tw:sm:px-6 tw:pt-5 tw:pb-8">
      <SectionTitle>Pending Update</SectionTitle>
      <div className="tw:flex tw:flex-wrap tw:mb-4 tw:gap-6">
        {pendingUpdatesFromOtherClouds.length ? (
          pendingUpdatesFromOtherClouds.map((app: ExtendedGlobalApp) => {
            return (
              <AppCard
                key={app.id}
                app={app}
                onClick={() => handleClick(app)}
                updating={installID === app.id}
                updateDisabled={!!installID}
                isGlobalApp
                onUpdate={() => {
                  installGlobalApp({
                    payload: {
                      globalAppID: app.id,
                      workspaceID: workspaceID as string,
                    },
                  });
                }}
              />
            );
          })
        ) : (
          <AppEmptyState
            title="No Pending Updates"
            description="All of your apps are up to date."
            className="tw:w-full"
          />
        )}
      </div>
      <SectionTitle>All Installed Apps</SectionTitle>
      <div className="tw:flex tw:flex-wrap tw:mb-4 tw:gap-6">
        {allInstalledApps.length ? (
          allInstalledApps.map((app: ExtendedGlobalApp) => {
            return (
              <AppCard
                key={app.id}
                app={app}
                onClick={() => handleClick(app)}
                isGlobalApp
              />
            );
          })
        ) : (
          <AppEmptyState
            title="No Installed Apps"
            description="You have no global apps installed."
            className="tw:w-full"
          />
        )}
      </div>
    </div>
  );
};

export default InstalledApps;
